// @ts-strict-ignore
import React, { useMemo } from 'react'
import AutoCompleteTextField, { IAutoCompleteOption } from 'components/AutoCompleteTextField'
import { FormValueInput, FormValueMeta } from 'types'
import { useTimezoneAutocomplete } from 'hooks/timezone'
import { timezones } from 'services/timeKeeping'

export interface ISelectTimezoneProps extends Omit<React.ComponentProps<typeof AutoCompleteTextField>, 'input' | 'options' | 'meta' | 'name'> {
  timezonesSecondaryText?: { [index: string]: string }
  input: FormValueInput<number>
  meta?: FormValueMeta
}

function SelectTimezone(props: ISelectTimezoneProps) {
  const { timezonesSecondaryText, input, ...restProps } = props

  const currentTimezone = useMemo(() => timezones.find(tz => tz.value === input.value), [input.value])

  const timezoneAutocomplete = useTimezoneAutocomplete(true)

  const handleChange = (value: IAutoCompleteOption) => {
    input.onChange(value?.value ?? null)
  }

  return (
    <AutoCompleteTextField
      input={{
        value: currentTimezone ? { value: currentTimezone.value, label: currentTimezone.title } : null,
        onChange: handleChange,
        name: input.name,
      }}
      helperText={timezonesSecondaryText?.[input.value]}
      {...restProps}
      {...timezoneAutocomplete}
    />
  )
}

export default React.memo(SelectTimezone)
